import TesoreriaPlaceholder from './TesoreriaPlaceholder.jsx';
import IngresosEgresosCaja from './Caja/IngresosEgresosCaja.jsx';
import CajasPage from './Caja/CajasPage.jsx';
import RegistrarCobranza from './Cobranzas/RegistrarCobranza.jsx';
import SeguimientoContrareembolsos from './Cobranzas/SeguimientoContrareembolsos.jsx';
import RendicionCobranzas from './Cobranzas/RendicionCobranzas.jsx';
import CuentasBancariasPage from './CuentasBancariasPage.jsx';

export const clipperTesoreriaRoutes = {
  '/tesoreria/caja/manejo-de-cajas': <CajasPage />,
  '/tesoreria/caja/ingresos-y-egresos-de-caja': <IngresosEgresosCaja />,
  '/tesoreria/caja/informes-de-caja-habituales': (
    <TesoreriaPlaceholder title="Informes de Caja Habituales" category="Caja" />
  ),
  '/tesoreria/caja/control-de-cajas': (
    <TesoreriaPlaceholder title="Control de Cajas" category="Caja" />
  ),
  '/tesoreria/caja/stock-de-comprobantes': (
    <TesoreriaPlaceholder title="Stock de Comprobantes" category="Caja" />
  ),
  '/tesoreria/cobranzas/determinar-recibos-por-cobranzas': (
    <TesoreriaPlaceholder title="Determinar Recibos por Cobranzas" category="Cobranzas" />
  ),
  '/tesoreria/cobranzas/rendicion-de-cobranzas': <RendicionCobranzas />,
  '/tesoreria/cobranzas/ingreso-de-recibos': (
    <RegistrarCobranza receiptMode="contrareembolso" />
  ),
  '/tesoreria/cobranzas/depositos-de-cobranzas-en-efectivo': (
    <TesoreriaPlaceholder title="Depositos de Cobranzas en Efectivo" category="Cobranzas" />
  ),
  '/tesoreria/cobranzas/seguimiento-de-contrareembolsos-cobrados': <SeguimientoContrareembolsos />,
  '/tesoreria/proveedores-y-pagos/consulta-debitos-y-creditos-acreedores': (
    <TesoreriaPlaceholder
      title="Consulta Debitos y Creditos Acreedores"
      category="Proveedores y Pagos"
    />
  ),
  '/tesoreria/proveedores-y-pagos/ajustes-de-saldos-para-proveedores': (
    <TesoreriaPlaceholder
      title="Ajustes de Saldos para Proveedores"
      category="Proveedores y Pagos"
    />
  ),
  '/tesoreria/proveedores-y-pagos/minutas-de-pago': (
    <TesoreriaPlaceholder title="Minutas de Pago" category="Proveedores y Pagos" />
  ),
  '/tesoreria/proveedores-y-pagos/resumen-de-cuenta-de-acreedores': (
    <TesoreriaPlaceholder
      title="Resumen de Cuenta de Acreedores"
      category="Proveedores y Pagos"
    />
  ),
  '/tesoreria/proveedores-y-pagos/analisis-de-deuda-proveedores': (
    <TesoreriaPlaceholder
      title="Analisis de Deuda Proveedores"
      category="Proveedores y Pagos"
    />
  ),
  '/tesoreria/proveedores-y-pagos/cheques-de-terceros': (
    <TesoreriaPlaceholder title="Cheques de Terceros" category="Proveedores y Pagos" />
  ),
  '/tesoreria/proveedores-y-pagos/stock-de-chequeras-propias': (
    <TesoreriaPlaceholder
      title="Stock de Chequeras Propias"
      category="Proveedores y Pagos"
    />
  ),
  '/tesoreria/impuestos/libro-iva-compras': (
    <TesoreriaPlaceholder title="Libro IVA Compras" category="Impuestos (IVA/Retenciones)" />
  ),
  '/tesoreria/impuestos/retenciones-emitidas-por-pagos': (
    <TesoreriaPlaceholder
      title="Retenciones Emitidas por Pagos"
      category="Impuestos (IVA/Retenciones)"
    />
  ),
  '/tesoreria/bancos-y-conciliacion/movimientos-bancarios': <CuentasBancariasPage />,
  '/tesoreria/bancos-y-conciliacion/maestro-de-monedas': (
    <TesoreriaPlaceholder title="Maestro de Monedas" category="Bancos y Conciliacion" />
  ),
  '/tesoreria/reportes': (
    <TesoreriaPlaceholder title="Reportes de Tesoreria" category="Reportes" />
  ),
};
